
import React from 'react';
import { Control } from 'react-hook-form';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useAuth } from '@/hooks/useAuth';

interface UserFormData {
  name?: string;
  email?: string;
  phone?: string;
  department?: string;
  role?: string;
  client_id?: string;
  status?: 'active' | 'inactive';
  groups?: string[];
}

interface UserRoleFieldsProps {
  control: Control<UserFormData>;
}

export const UserRoleFields = ({ control }: UserRoleFieldsProps) => {
  const { profile } = useAuth();
  
  // Verificar se o usuário atual é admin global
  const isGlobalAdmin = profile?.role === 'admin' || profile?.role === 'super_admin';
  
  // Roles disponíveis baseado no tipo de usuário atual
  const availableRoles = isGlobalAdmin 
    ? [
        { value: 'admin', label: 'Administrador' },
        { value: 'super_admin', label: 'Super Administrador' },
        { value: 'client_admin', label: 'Admin do Cliente' },
        { value: 'manager', label: 'Gerente' },
        { value: 'technician', label: 'Técnico' },
        { value: 'user', label: 'Usuário' },
      ]
    : [
        // Client_admin só pode criar roles abaixo de admin
        { value: 'client_admin', label: 'Admin do Cliente' },
        { value: 'manager', label: 'Gerente' },
        { value: 'technician', label: 'Técnico' },
        { value: 'user', label: 'Usuário' },
      ];

  return (
    <div className="grid grid-cols-2 gap-4">
      <FormField
        control={control}
        name="role"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Função *</FormLabel>
            <Select onValueChange={field.onChange} value={field.value}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Selecione a função" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {availableRoles.map((role) => (
                  <SelectItem key={role.value} value={role.value}>
                    {role.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="status"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Status *</FormLabel>
            <Select onValueChange={field.onChange} value={field.value}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Selecione o status" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="active">Ativo</SelectItem>
                <SelectItem value="inactive">Inativo</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
